import {
    SET_ASCENDING,
    SET_MAX_VISIBLE,
    SET_TIMEOUT_BAR_VISIBILITY,
    SET_REPEAT_COUNT_VISIBILITY,
} from './constants'

// Initial state of the store
const initialState = {
    ascending: true,
    maxOnScreen: 5,
    showTimeoutBar: true,
    showRepeatCount: false,
}

const reducer = (state = initialState, action) => {
    const { payload, type } = action
    switch (type) {
        // Change ascending
        case SET_ASCENDING:
            return {
                ...state,
                ascending: payload,
            }

        // Set max visible on screen
        case SET_MAX_VISIBLE:
            return {
                ...state,
                maxOnScreen: payload,
            }

        // Show or hide the timeout bar
        case SET_TIMEOUT_BAR_VISIBILITY:
            return {
                ...state,
                showTimeoutBar: payload,
            }

        // Show or hide the amount of times a toast has been requested
        case SET_REPEAT_COUNT_VISIBILITY:
            return {
                ...state,
                showRepeatCount: payload,
            }

        // Default state
        default:
            return state
    }
}

export default reducer



// WEBPACK FOOTER //
// ./src/features/Toaster/data/settings/reducer.js